import styled from 'styled-components';
import { Box, useViewportSize } from '@lemonade-hq/cdk';
import { lerp, clampedInversedLerp } from '@lemonade-hq/ts-helpers';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';

const Container = styled(Box)`
  overflow: hidden;

  ${MEDIA_QUERIES.upToDesktop`
        border-radius: 9px;
    `}

  ${MEDIA_QUERIES.desktop`
        border-radius: 19px;
    `}
`;

const Stripe = styled(Box)`
  width: 100%;
  overflow: hidden;

  ${MEDIA_QUERIES.upToDesktop`
        height: 16px;
    `}

  ${MEDIA_QUERIES.desktop`
        height: 33px;
    `}
`;

export default function Giveback2020LGBT({ t, ...props }) {
  const { isBelowDesktopViewport } = useViewportSize();
  const pinkWidth = lerp(0, 100, t);
  const borderRadius = isBelowDesktopViewport ? 9 : 19;
  const startRoundBorder = lerp(borderRadius, 0, clampedInversedLerp(0, 0.1, t));
  const endRoundBorder = lerp(borderRadius, 0, clampedInversedLerp(0.95, 1.0, t));
  const capRoundBorder = lerp(borderRadius, 0, clampedInversedLerp(0.95, 1.0, t));

  return (
    <Container {...props}>
      <Stripe backgroundColor="#2C2C2C" />
      <Stripe
        backgroundColor="#A3652D"
        style={{
          borderRadius: `0 0 ${endRoundBorder}px ${startRoundBorder}px`,
        }}
      />
      <Stripe
        backgroundColor="#FF0083"
        style={{
          width: `${pinkWidth}%`,
          borderRadius: `${startRoundBorder}px ${capRoundBorder}px ${capRoundBorder}px ${startRoundBorder}px`,
        }}
      />
      <Stripe
        backgroundColor="#FF321B"
        style={{
          borderRadius: `${startRoundBorder}px ${endRoundBorder}px 0 0`,
        }}
      />
      <Stripe backgroundColor="#FF9513" />
      <Stripe backgroundColor="#FFED00" />
      <Stripe backgroundColor="#03B01F" />
      <Stripe backgroundColor="#2A45E7" />
      <Stripe backgroundColor="#A947DA" />
    </Container>
  );
}
